var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30253",
    "data-name": "Rectangle 30253",
    width: 16,
    height: 16,
    transform: "translate(1227 30)",
    fill: "#7e59d1",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_853",
    "data-name": "Mask Group 853",
    transform: "translate(-1227 -30)",
    clipPath: "url(#clock)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-08-22T143931.408",
    "data-name": "svgexport-6 - 2022-08-22T143931.408",
    transform: "translate(1227 30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85898",
    "data-name": "Group 85898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47944",
    "data-name": "Path 47944",
    d: "M8,0a8,8,0,1,0,8,8A8.017,8.017,0,0,0,8,0ZM8,15.063A7.063,7.063,0,1,1,15.063,8,7.07,7.07,0,0,1,8,15.063Z",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3243",
    "data-name": "Ellipse 3243",
    cx: 0.469,
    cy: 0.469,
    r: 0.469,
    transform: "translate(3.554 11.509)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3244",
    "data-name": "Ellipse 3244",
    cx: 0.469,
    cy: 0.469,
    r: 0.469,
    transform: "translate(11.509 3.554)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47945",
    "data-name": "Path 47945",
    d: "M3.691,3.691a.469.469,0,1,0,.663,0A.469.469,0,0,0,3.691,3.691Z",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47946",
    "data-name": "Path 47946",
    d: "M11.646,11.646a.469.469,0,1,0,.663,0A.469.469,0,0,0,11.646,11.646Z",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47947",
    "data-name": "Path 47947",
    d: "M8,3.781a.469.469,0,0,0,.469-.469V2.375a.469.469,0,0,0-.937,0v.938A.469.469,0,0,0,8,3.781Z",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47948",
    "data-name": "Path 47948",
    d: "M8,12.219a.469.469,0,0,0-.469.469v.938a.469.469,0,0,0,.938,0v-.937A.469.469,0,0,0,8,12.219Z",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47949",
    "data-name": "Path 47949",
    d: "M3.781,8a.469.469,0,0,0-.469-.469H2.375a.469.469,0,0,0,0,.938h.938A.469.469,0,0,0,3.781,8Z",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47950",
    "data-name": "Path 47950",
    d: "M12.219,8a.469.469,0,0,0,.469.469h.938a.469.469,0,0,0,0-.937h-.937A.469.469,0,0,0,12.219,8Z",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47951",
    "data-name": "Path 47951",
    d: "M8.469,7.806V5.188a.469.469,0,0,0-.937,0V8a.469.469,0,0,0,.137.331l2.812,2.813a.469.469,0,0,0,.663-.663Z",
    fill: "#7e59d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.85bf4fea3564656942358172a221a739.svg";
export { ForwardRef as ReactComponent };